import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalUserAuthProvider } from '@/app/store/api/restApi';

export interface ProfileState {
  name?: string;
  login?: string;
  photoUrl?: string;
  provider?: GlobalUserAuthProvider;
  verifiedEmail?: string;
}

const initialState: ProfileState = {};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,

  reducers: {
    setUserName(state, { payload }: PayloadAction<string | undefined>) {
      state.name = payload;
    },
    setLogin(state, { payload }: PayloadAction<string | undefined>) {
      state.login = payload;
    },
    setPhotoUrl(state, { payload }: PayloadAction<string | undefined>) {
      state.photoUrl = payload;
    },
    setProvider(state, { payload }: PayloadAction<GlobalUserAuthProvider | undefined>) {
      state.provider = payload;
    },
    setVerifiedEmail(state, { payload }: PayloadAction<string | undefined>) {
      state.verifiedEmail = payload;
    },
    resetProfile() {
      return initialState;
    },
  },
});

export const { setUserName, setLogin, setPhotoUrl, setProvider, setVerifiedEmail, resetProfile } = profileSlice.actions;

export const profileReducer = profileSlice.reducer;
